export const ApiRoutes = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL,
  // BASE_URL: process.env.REACT_APP_API_STUB_BASE_URL,
  USER_LOGIN: "/users/login",
  USER_LOGOUT: "/users/logout",
  GET_USER: "/users/me",
  GET_USER_WALLET: "/users/my-wallet",
  FORGOT_PASSWORD: "/forgot-password",
  GET_USER_WALLET_HISTORY: "/users/wallet/history",
  EMERGENCY_CONTACT: "users/emergency-contact",
  BENEFICIARY_DETAILS: "users/beneficiary-details",
  CREATE_ACCOUNT: "/v2/users/signup",
  OTP_VERIFICATION: "/v2/users/verify/email",
  RESEND_OTP: "/resend-otp",
  CASES: "/cases",
  DICOM_DATA: "/scan_center/dicom_data",
  AUTO_RENEWAL: "/subscription/auto-renewal",
  KYC_STEP: "/v2/kyc/step",
  USER_ROLE_INFO: "/kyc/basic-info",
  USER_ROLE_INFO_UPDATE: "/kyc/particular-basic-info",
  USER_ROLE_INFO_NAME: "/kyc/basic-info/name",
  ID_PROOF_UPLOAD: "/v2/kyc/id-proof",
  VIDEO_PROOF_UPLOAD: "/kyc/video-proof",
  VIDEO_UPLOAD_LINK: "/kyc/video-proof/generate-upload-link",
  VIDEO_PROOF_CODE: "/kyc/video-proof/verification-code",
  RISK_ASSESMENT_QUESTIONS: "/v2/kyc/risk-assesment/questions",
  RISK_ASSESMENT: "/v2/kyc/risk-assesment",
  SUITABILITY_QUIZ_QUESTIONS: "/kyc/suitability-quiz/questions",
  SUITABILITY_QUIZ_ATTEMPT: "/kyc/suitability-quiz/attempt",
  SUITABILITY_QUIZ_ANSWER: "/kyc/suitability-quiz/attempt/questions/:question_id/answer",
  KYC_BANK_DETAILS: "/kyc/bank-details",
  SUBSCRIPTION: "/subscription",
  SUBSCRIPTIONS: "/subscription/plans",
  SUBSCRIPTIONS_AMOUNT: "/subscription/:id",

  SHARES: "/orders/buy",
  SHARES_HISTORY: "/shares/order/history",
  SHARES_OPTION: "/shares/order/option",
  SHARES_SELL: "/orders/sell",
  SHARES_BREAKDOWN: "/shares/order/option/breakdown",
  SHARES_SELL_OPTION: "/shares/sell-order/option",
  SHARES_SELL_HISTORY: "/shares/sell-order/history",
  SHARES_SELL_BREAKDOWN: "/shares/sell-order/option/breakdown",
  PAYMENT: "/payment/mpesa-request",
  WITHDRAW: "/withdraw-requests",
  VERIFY_WITHDRAW_OTP: "/withdraw-requests/:id/verify",
  RESEND_WITHDRAW_OTP: "/withdraw-requests/:id/resend-otp",
  INVITE: "/users/invite",
  FAQ: "/information/faq",
  TERMS_AND_CONDITIONS: "/information/general/terms_and_conditions",
  CURRENT_VALUATION: `/users/me/current-valuation`,
  SUPPORT_CONTACTS: "/users/me/support-contacts",

  META_RELATION: "meta/relations",
  COUNTRIES: "/meta/countries",
  AUTO_DIVIDEND_OTP: "/users/me/send-otp",
  AUTO_DIVIDEND_INVEST: "/users/me/invest-option",
  APP_NOTIFICATIONS: "/users/notifications",
  MARK_ALL_AS_READ: "/users/notifications/mark-all-read",
  MARK_READ: "/users/notifications/mark-read",
  CONFIRM_ORDER: "/admin/orders/confirm-order",

  TRADING_REPORT: "/users/me/reports/trading-report",
  AVAILABLE_PERIOD: "/users/me/reports/trading-report/available-periods",
  GROUP_DETAILS: "/kyc/chamas",
  GROUP_DETAILS_BASIC_DETAILS: "v2/kyc/basic-info",
  GET_GENDER: "/meta/genders",
  GET_EMPLOYMENT_STATUS: "/meta/employment-statuses",
  GROUP_DETAILS_MEMBERS: "/kyc/chamas/invite",
  GET_EMAIL_SENT_OTP: "/users/send-sms-otp",
  UPDATE_EMAIL_OTP: "/users/update-email",
  UPDATE_EMAIL_VERIFY_OTP: "/users/verify-email-otp",
  GET_PHONE_SENT_OTP: "/users/send-email-otp",
  UPDATE_PHONE_OTP: "/users/update-phone-number",
  UPDATE_PHONE_VERIFY_OTP: "/users/verify-sms-otp",
  USERS_RESEND_OTP: "/users/resend-otp",
  CREDIT_CARD: "/payment/credit-card/link",
  GET_SSO_URL: "/auth/google/url",
  SSO_REGISTER: "/auth/google/verify",
  APPLE_AUTH: "/auth/apple",
  GET_GROUP_DETAILS_BASIC_DETAILS: "/kyc/basic-info",
  UPDATE_GROUP_DETAILS_BASIC_DETAILS: "/v2/kyc/basic-info/:basic_info_id",
  UPDATE_GROUP_DETAILS_MEMBERS: "/kyc/chama-people",
  ADD_PHONE_NUMBER: "/users/phone-update",
  VERIFY_ADD_PHONE: "/users/phone-otp/verify",
  GET_QUOTE: "/orders/quote",
  GET_HISTORY: "/orders",
  GET_INVESTMENT_SUMMARY: "/users/me/investment-summary",
  TIER_PROGRESSION: "/users/me/tier-progression",
  CONFIRM_CLOSE_ACCOUNT: "/users/me/close-account/send-otp",
  VERIFY_CLOSE_ACCOUNT: "/users/me/close-account/verify",
  UNIT_SUGGESTION: "/orders/unit-suggestions",
  AMOUNT_SUGGESTION: "/orders/amount-suggestions",
  USER_WALLET_AUTO_INVEST: "/users/me/wallet-auto-invest",
  TWO_FA_INIT: "/auth/2fa/init",
  TWO_FA_VERIFY: "/auth/2fa/verify",
  APPLY_REFERRAL_CODE: "/users/me/referral-code",
  CHANGE_PASSWORD: "/users/me/password",
  CHANGE_PASSWORD_OTP: "/users/me/password/send-otp",
};
